import * as React from "react"
import { SFProIcon, SFProIconProps } from "./SFProIcon"

export interface ArrowDownIconProps extends Omit<SFProIconProps, 'symbol'> {}

/**
 * Arrow Down icon using SF Pro font symbol (􀙱)
 *
 * This icon represents a downward direction or movement,
 * used in the pairing help view to indicate bringing the phone close to the product.
 *
 * @example
 * ```tsx
 * <ArrowDownIcon />
 * <ArrowDownIcon size={10} weight="medium" />
 * ```
 */
export const ArrowDownIcon = React.forwardRef<HTMLSpanElement, ArrowDownIconProps>(
  (props, ref) => {
    return <SFProIcon ref={ref} symbol="􀙱" {...props} />
  }
)

ArrowDownIcon.displayName = "ArrowDownIcon"
